// removed by extract-text-webpack-plugin
module.exports = {"option":"option___1czp7","backer":"backer___2AY5x","select":"select___2kHya","label":"label___20kBV"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/EditVariable/ChoiceFromReferenceEditor/styles.scss
// module id = 412
// module chunks = 0